export enum ScreenWidth {
  Medium = 992
}
